/** ToDo 타임테이블·예산 노트 등에서 공유: 월.일 입력·ISO YMD */

export const WD_SHORT = ['일', '월', '화', '수', '목', '금', '토'];

export function parseYmd(iso: string): { y: number; mo: number; d: number } {
  const [ys, ms, ds] = iso.split('-');
  const y = Number(ys);
  const mo = Number(ms);
  const d = Number(ds);
  const yy = Number.isFinite(y) ? y : new Date().getFullYear();
  const mm = Number.isFinite(mo) ? Math.min(12, Math.max(1, mo)) : 1;
  const dd = Number.isFinite(d) ? Math.min(31, Math.max(1, d)) : 1;
  return { y: yy, mo: mm, d: dd };
}

export function lastDayOfMonth(y: number, mo: number): number {
  return new Date(y, mo, 0).getDate();
}

export function isoFromYmd(y: number, mo: number, d: number): string {
  const cap = lastDayOfMonth(y, mo);
  const dd = Math.min(cap, Math.max(1, d));
  return `${y}-${String(mo).padStart(2, '0')}-${String(dd).padStart(2, '0')}`;
}

export function weekdayShortKo(y: number, mo: number, d: number): string {
  return WD_SHORT[new Date(y, mo - 1, d).getDay()];
}

/** `m.d` (월.일) 예: 4.29 → 4월 29일 */
export function tryParseMonthDayDot(draft: string, y: number): { mo: number; d: number } | null {
  const t = draft.trim().replace(/,/g, '.');
  const parts = t
    .split('.')
    .map((p) => p.trim())
    .filter((p) => p.length > 0);
  if (parts.length < 2) return null;
  const mo0 = parseInt(parts[0], 10);
  const d0 = parseInt(parts[1], 10);
  if (!Number.isFinite(mo0) || !Number.isFinite(d0)) return null;
  if (mo0 < 1 || mo0 > 12) return null;
  const cap = lastDayOfMonth(y, mo0);
  if (d0 < 1 || d0 > cap) return null;
  return { mo: mo0, d: d0 };
}

/**
 * 일 모드 입력란에서 월만으로 전환할 때: `4`, `4.`, `4.0` 등.
 * `4.1`처럼 일이 1 이상이면 null (일반 월.일로 처리).
 */
export function tryParseMonthOnlyFromDayDraft(draft: string): { mo: number } | null {
  const raw = draft.trim().replace(/,/g, '.');
  if (raw === '') return null;

  if (!raw.includes('.')) {
    const m = parseInt(raw, 10);
    if (!Number.isFinite(m) || m < 1 || m > 12) return null;
    return { mo: m };
  }

  const parts = raw.split('.');
  const m0 = parseInt(parts[0]?.trim() ?? '', 10);
  if (!Number.isFinite(m0) || m0 < 1 || m0 > 12) return null;

  if (parts.length < 2) return { mo: m0 };

  const dayPart = parts[1]?.trim() ?? '';
  if (dayPart === '') return { mo: m0 };

  const d0 = parseInt(dayPart, 10);
  if (!Number.isFinite(d0)) return { mo: m0 };
  if (d0 === 0) return { mo: m0 };

  return null;
}

export function tryParseMonthNum(draft: string): number | null {
  const t = draft.trim().replace(/,/g, '.');
  const head = t.split('.')[0]?.trim() ?? '';
  const m = parseInt(head, 10);
  if (!Number.isFinite(m) || m < 1 || m > 12) return null;
  return m;
}

export function buildDueCalendarCells(y: number, mo: number): (number | null)[] {
  const firstWeekday = new Date(y, mo - 1, 1).getDay();
  const dim = lastDayOfMonth(y, mo);
  const cells: (number | null)[] = [];
  for (let i = 0; i < firstWeekday; i += 1) cells.push(null);
  for (let day = 1; day <= dim; day += 1) cells.push(day);
  while (cells.length % 7 !== 0) cells.push(null);
  return cells;
}
